export default function SetupCustomFinance({ product, price }) {

    return (<></>);
}
